import { apiGet, apiPatch, apiPost } from '../../../shared/api-client/index.js';

export interface TemplateItem {
  id: string;
  workspaceId: string;
  name: string;
  type: 'email' | 'sms' | 'in_app';
  subject?: string | null;
  body: string;
  variables: string[];
  isActive: boolean;
  usageCount: number;
}

export interface ListTemplatesFilters {
  channel?: 'email' | 'sms' | 'in_app';
}

export interface UpdateTemplateInput {
  body?: string;
  subject?: string | null;
}

export interface CreateTemplateInput {
  name: string;
  type: 'email' | 'sms' | 'in_app';
  body: string;
  subject?: string | null;
}

export function getTemplatesQueryKey(workspaceId: string, filters?: ListTemplatesFilters): readonly [string, string, string] {
  return ['templates', workspaceId, filters?.channel ?? 'all'] as const;
}

export async function listTemplates(filters: ListTemplatesFilters = {}): Promise<TemplateItem[]> {
  const search = new URLSearchParams();
  if (filters.channel) {
    search.set('channel', filters.channel);
  }
  const path = search.size > 0 ? `/templates?${search.toString()}` : '/templates';
  return apiGet<TemplateItem[]>(path);
}

export async function updateTemplate(templateId: string, input: UpdateTemplateInput): Promise<TemplateItem> {
  return apiPatch<TemplateItem, UpdateTemplateInput>(`/templates/${templateId}`, input);
}

export async function createTemplate(input: CreateTemplateInput): Promise<TemplateItem> {
  return apiPost<TemplateItem, CreateTemplateInput>('/templates', input);
}
